module.exports = __webpack_public_path__ + "static/media/great-react.33cf9fc2.png";